<p>
  Функцията за блокиране ви позволява да ограничите взаимодействието с конкретен потребител в платформата. Тя е
  предназначена за ситуации, при които искате да избегнете нежелани комуникации, нежелано участие в обяви или съмнително
  поведение.
</p>
<h6 class="mt-3">Как да блокирате потребител?</h6>
<p>
  Навигирайте до <strong>профила на съответния потребител</strong>, изберете бутона <strong>„Още“</strong>, след което
  натиснете <strong>„Блокирай потребителя“</strong>.
</p>
<h6 class="mt-3">Какво се случва при блокиране?</h6>
<p class="mb-1">
  Блокираните потребители:
</p>
<ul>
  <li>не могат да потвърждават покупки за вашите артикули;</li>
  <li>не могат да участват в наддавания на вашите търгове;</li>
  <li>не могат да публикуват публични коментари под вашите обяви.</li>
</ul>
<h6 class="mt-3">Къде да намерите списъка с блокирани потребители?</h6>
<p>
  Всички блокирани от вас потребители се съхраняват в секцията
  <strong>„Профил“ → „Настройки“ → „Блокирани потребители“</strong>. Оттам може да управлявате и променяте списъка по
  всяко време.
</p>
<h6 class="mt-3">Как да деблокирате потребител?</h6>
<p class="mb-1">Имате два начина да премахнете блокирането:</p>
<ul>
  <li>От <strong>профила на потребителя</strong>, чрез бутона <strong>„Още“</strong> → <strong>„Деблокирай
    потребителя“</strong>.
  </li>
  <li>От <strong>списъка с блокирани потребители</strong>, като натиснете бутона <strong>„Деблокирай“</strong> до името
    на съответния потребител.
  </li>
</ul>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Използвайте блокирането само когато е наистина необходимо. Ако даден потребител нарушава
  правилата на платформата, сигнализирайте чрез
  <a class="text-decoration-none"
     [routerLink]="[appRoutes.root, appRoutes.contactUs]">
    формата за контакт.
  </a>
</div>
